import {
  LetterIcon,
  LinkIcon,
  PhoneIcon,
  Table,
  TableData,
} from "~/common/components";
import { formatPhoneNumberMethod } from "~/common/utils";
import { SchedulingMethod } from "../types/schedulingMethods";

export const SchedulingMethodsTable = ({
  data,
}: {
  data?: SchedulingMethod;
}) => {
  const phone = formatPhoneNumberMethod(data?.phone_number);

  return (
    <Table className="size-full table-auto text-gray-700">
      <tbody>
        <tr key={`phone`}>
          <TableData className="w-1 border-t-0 pl-0">
            <PhoneIcon width={20} />
          </TableData>
          <TableData className="w-40 text-nowrap border-t-0 pl-0">
            Phone number
          </TableData>
          <TableData className="border-t-0">{phone || <>&ndash;</>}</TableData>
        </tr>

        <tr key={`email`}>
          <TableData className="w-1 pl-0">
            <LetterIcon width={20} />
          </TableData>

          <TableData className="w-40 text-nowrap pl-0">Email</TableData>
          <TableData>
            {data?.email ? (
              <a
                className="underline"
                href={`mailto:${data.email}`}
                rel="noreferrer"
                target="_blank"
              >
                {data.email}
              </a>
            ) : (
              <>&ndash;</>
            )}
          </TableData>
        </tr>

        <tr key={`calendar`}>
          <TableData className="w-1 pl-0">
            <LinkIcon />
          </TableData>
          <TableData className="w-40 text-nowrap pl-0">Booking link</TableData>
          <TableData>
            {data?.booking_link ? (
              <a
                className="underline"
                href={data.booking_link}
                rel="noreferrer"
                target="_blank"
              >
                {data.booking_link}
              </a>
            ) : (
              <>&ndash;</>
            )}
          </TableData>
        </tr>
      </tbody>
    </Table>
  );
};
